import { createSelector } from '@ngrx/store';
import { BaseState } from '../base.state';

export const selectEndorsementsState = (state: BaseState) => state.endorsements;

export const selectEndorsementsIsLoading = createSelector(
  selectEndorsementsState,
  (state) => state.isLoading
);